import { Eye } from "tabler-icons-react";

export const MajorHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },
  {
    id: "majorName",
    numeric: false,
    disablePadding: true,
    label: "Major",
  },
  {
    id: "majorDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  {
    id: "state",
    numeric: false,
    disablePadding: true,
    label: "Status",
  },
  {
    id: "actions",
    view: <Eye />,
    numeric: false,
    label: "Actions",
  },
];
